import { from } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import { utilBuildings } from "../../../utils/utilBuildings";
import { utilProduction } from "../../../utils/utilProduction";
import { actionModalCloseAll } from "../../modals/actionModal";
import { actionBuildingsSelect, actionBuildingsShowBouncingArrow, } from "../../player-base/buildings/actionBuildings";
import { selectBuildingMaxStage } from "../selectors/selectBuildingMaxStage";
export var createPathSelectBuildingMaxLevel = function (getBuildings) { return function (action, state$, deps) {
    return deps.inStoreDependencies.viewportChanged$.pipe(take(1), switchMap(function (viewport) {
        var buildings = getBuildings(action, state$, deps);
        var maxLevelBuilding = selectBuildingMaxStage(buildings);
        var origin = utilBuildings.getCenterPositionOnScreen(maxLevelBuilding, viewport);
        var actions = [
            actionModalCloseAll(),
            actionBuildingsSelect(maxLevelBuilding, origin, true),
        ];
        if (action.taskType && action.taskType.resourceId) {
            var recipeId = parseInt(action.taskType.recipeIds, 10);
            utilProduction.setProductionRecipe(recipeId, maxLevelBuilding.balancing.id);
        }
        if (action.taskType && action.taskType.stage && !maxLevelBuilding.proto.remainingTime) {
            actions.push(actionBuildingsShowBouncingArrow(maxLevelBuilding, true));
        }
        return from(actions);
    }));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/createPathSelectBuildingMaxLevel.ts
// module id = 258
// module chunks = 3